var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 30,
    viewBox: "0 0 490 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.688 16.2452H1.3132C0.586077 16.2452 0 15.6575 0 14.9337C0 14.2066 0.587756 13.6205 1.3132 13.6205H488.688C489.411 13.6205 490 14.2083 490 14.9337C490 15.6591 489.411 16.2452 488.688 16.2452Z",
    fill: "url(#paint0_linear_58_209)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9944 15.3098C22.7291 15.3098 22.4587 15.2309 22.2253 15.063C21.6392 14.6381 21.5082 13.8153 21.9331 13.2292C25.3017 8.58767 29.3857 3.58678 35.2649 3.01247C40.3044 2.50869 44.7259 5.47936 48.647 8.08728C52.5312 10.6717 56.5884 12.885 60.4893 11.9429C62.5783 11.4374 63.9302 9.88579 65.0805 8.29048C66.3214 6.56418 66.9361 4.35591 66.7648 2.24002C66.7077 1.51793 67.2467 0.884846 67.9688 0.826072C68.7077 0.770656 69.3257 1.30802 69.3828 2.03011C69.6028 4.75725 68.8118 7.59523 67.2132 9.82196C65.8361 11.7347 64.0343 13.785 61.1073 14.4954C56.2323 15.6793 51.574 13.1889 47.2717 10.3241C43.4631 7.79005 39.6142 5.23248 35.5235 5.62543C30.7292 6.09395 27.2295 10.3996 24.0591 14.7708C23.8004 15.1234 23.4008 15.3098 22.9944 15.3098Z",
    fill: "url(#paint1_linear_58_209)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.688 14.7524C13.5436 14.7524 13.3958 14.7255 13.2514 14.6768C12.5663 14.435 12.2086 13.6843 12.4487 13.0042C12.6402 12.4568 12.5931 11.7582 12.5461 11.0126C12.4924 10.22 12.4319 9.32328 12.6502 8.41143C13.0566 6.71536 14.4034 5.30644 16.0827 4.82449C17.7704 4.34254 19.6528 4.8245 20.8972 6.04869C22.0374 7.17213 22.4539 8.64485 22.8216 9.94629C23.0601 10.7876 23.2834 11.5802 23.668 12.2133C24.0441 12.833 23.8443 13.639 23.2247 14.0152C22.6067 14.3914 21.7989 14.1915 21.4211 13.5702C20.8552 12.6365 20.5697 11.6323 20.296 10.6617C19.9753 9.52982 19.6999 8.55418 19.0567 7.9211C18.4824 7.35686 17.5789 7.1251 16.8048 7.34676C16.034 7.56675 15.3891 8.24348 15.2027 9.02266C15.0768 9.54492 15.1188 10.1713 15.1641 10.838C15.2279 11.765 15.2985 12.8162 14.9257 13.8724C14.7342 14.4115 14.2288 14.7524 13.688 14.7524Z",
    fill: "url(#paint2_linear_58_209)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 15.1252C85.7755 15.1252 85.1895 14.5358 85.1895 13.8137V1.3115C85.1895 0.586052 85.7772 0 86.501 0C87.2281 0 87.8142 0.587732 87.8142 1.3115V13.8137C87.8142 14.5375 87.2281 15.1252 86.501 15.1252Z",
    fill: "url(#paint3_linear_58_209)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0763 29.0316C68.041 29.0316 68.0058 29.0299 67.9688 29.0299C67.2467 28.9677 66.7077 28.3397 66.7648 27.6143C66.9361 25.4967 66.3215 23.2918 65.0788 21.5638C63.9285 19.9685 62.5783 18.4168 60.4893 17.9114C56.5934 16.971 52.5346 19.1859 48.726 21.72C44.7259 24.3783 40.2826 27.3473 35.2649 26.8418C29.3857 26.2675 25.3 21.2683 21.9331 16.6267C21.5082 16.0407 21.6392 15.2178 22.2253 14.7913C22.8113 14.3664 23.6308 14.4991 24.0591 15.0852C27.2295 19.4546 30.7292 23.7603 35.5235 24.2322C39.6025 24.6251 43.4648 22.0626 47.1928 19.5856C51.574 16.6687 56.2374 14.1733 61.1073 15.3589C64.0343 16.0675 65.8345 18.1196 67.2115 20.0307C68.8118 22.2557 69.6028 25.097 69.3828 27.8242C69.3291 28.5127 68.7531 29.0316 68.0763 29.0316Z",
    fill: "url(#paint4_linear_58_209)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4058 25.2161C16.9608 25.2161 16.5158 25.154 16.0859 25.0314C14.4033 24.5511 13.0565 23.1389 12.6501 21.4428C12.4318 20.5293 12.4922 19.6325 12.546 18.8399C12.593 18.0993 12.6417 17.3974 12.4486 16.8517C12.2068 16.1682 12.5645 15.4175 13.2513 15.1757C13.9364 14.9456 14.6854 15.2933 14.9255 15.9801C15.2983 17.0347 15.2278 18.0876 15.164 19.0162C15.1203 19.6812 15.0767 20.3093 15.2026 20.8282C15.389 21.6107 16.0338 22.2841 16.8063 22.5074C17.5754 22.7224 18.4822 22.494 19.0566 21.9332C19.6997 21.2967 19.9751 20.3227 20.2959 19.1892C20.5696 18.2203 20.8551 17.2144 21.421 16.2807C21.7971 15.6627 22.6065 15.4629 23.2245 15.8374C23.8442 16.2135 24.0423 17.0213 23.6678 17.6409C23.2833 18.2706 23.0599 19.0666 22.8215 19.908C22.452 21.206 22.0356 22.6804 20.897 23.8038C19.9717 24.714 18.6921 25.2161 17.4058 25.2161Z",
    fill: "url(#paint5_linear_58_209)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 29.8557C85.7755 29.8557 85.1895 29.2663 85.1895 28.5442V16.0437C85.1895 15.3148 85.7772 14.7322 86.501 14.7322C87.2281 14.7322 87.8142 15.3165 87.8142 16.0437V28.5442C87.8142 29.2663 87.2281 29.8557 86.501 29.8557Z",
    fill: "url(#paint6_linear_58_209)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.502 15.3099C467.097 15.3099 466.697 15.1251 466.434 14.7708C463.265 10.398 459.767 6.09397 454.974 5.62545C450.882 5.21739 447.033 7.79174 443.305 10.272C438.922 13.1889 434.271 15.686 429.386 14.4971C426.457 13.7868 424.658 11.7347 423.283 9.82367C421.683 7.60199 420.892 4.76062 421.108 2.0318C421.171 1.30971 421.802 0.777384 422.524 0.827762C423.248 0.883178 423.785 1.51962 423.728 2.24171C423.56 4.36096 424.176 6.56416 425.417 8.29214C426.566 9.88745 427.918 11.4391 430.005 11.9446C433.906 12.8934 437.962 10.6734 441.772 8.13932C445.772 5.47766 450.217 2.51376 455.231 3.01419C461.109 3.5885 465.194 8.58939 468.565 13.2309C468.991 13.817 468.857 14.6398 468.271 15.0647C468.039 15.231 467.767 15.3099 467.502 15.3099Z",
    fill: "url(#paint7_linear_58_209)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M476.807 14.7524C476.27 14.7524 475.762 14.4132 475.573 13.8742C475.198 12.8179 475.269 11.7666 475.331 10.8397C475.376 10.173 475.418 9.54665 475.296 9.02439C475.106 8.24521 474.459 7.56848 473.692 7.3485C472.916 7.12683 472.014 7.35854 471.44 7.92278C470.799 8.55587 470.521 9.53156 470.199 10.6634C469.927 11.634 469.642 12.6399 469.077 13.5719C468.698 14.1932 467.892 14.3897 467.27 14.0169C466.651 13.639 466.453 12.8347 466.83 12.215C467.212 11.5819 467.435 10.7893 467.675 9.94803C468.041 8.64659 468.461 7.17384 469.6 6.0504C470.846 4.82621 472.738 4.34425 474.414 4.8262C476.097 5.30815 477.44 6.71709 477.85 8.41317C478.066 9.32501 478.004 10.2217 477.952 11.0143C477.902 11.7583 477.853 12.4568 478.05 13.006C478.291 13.6861 477.934 14.4384 477.244 14.6785C477.099 14.7256 476.951 14.7524 476.807 14.7524Z",
    fill: "url(#paint8_linear_58_209)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M403.994 15.1252C403.265 15.1252 402.683 14.5358 402.683 13.8137V1.3115C402.683 0.586052 403.267 0 403.994 0C404.72 0 405.307 0.587732 405.307 1.3115V13.8137C405.307 14.5375 404.718 15.1252 403.994 15.1252Z",
    fill: "url(#paint9_linear_58_209)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M422.415 29.0313C421.74 29.0313 421.164 28.5107 421.108 27.8239C420.892 25.0967 421.683 22.2571 423.283 20.0304C424.657 18.1177 426.457 16.0672 429.386 15.3586C434.261 14.1747 438.922 16.6667 443.223 19.5282C447.033 22.0656 450.899 24.6383 454.974 24.2302C459.767 23.7583 463.267 19.4527 466.434 15.0832C466.864 14.4971 467.685 14.3645 468.269 14.7893C468.855 15.2159 468.99 16.0387 468.563 16.6248C465.193 21.2663 461.107 26.2655 455.23 26.8398C450.19 27.3402 445.765 24.3763 441.847 21.7684C437.96 19.1806 433.891 16.9674 430.004 17.9094C427.916 18.4149 426.563 19.9665 425.416 21.5618C424.175 23.2898 423.56 25.4964 423.726 27.6123C423.783 28.3377 423.246 28.9708 422.522 29.0279C422.487 29.0313 422.454 29.0313 422.415 29.0313Z",
    fill: "url(#paint10_linear_58_209)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M473.091 25.2142C471.803 25.2142 470.522 24.7138 469.598 23.8053C468.46 22.6819 468.04 21.2075 467.674 19.9094C467.434 19.0681 467.21 18.2721 466.829 17.6424C466.45 17.0228 466.65 16.2133 467.269 15.8389C467.89 15.4661 468.702 15.6642 469.076 16.2821C469.64 17.2175 469.926 18.2217 470.198 19.1907C470.52 20.3242 470.797 21.2982 471.439 21.9346C472.013 22.4989 472.92 22.7289 473.691 22.5056C474.458 22.2856 475.105 21.6122 475.294 20.833C475.417 20.3108 475.377 19.681 475.33 19.0177C475.268 18.0891 475.197 17.0362 475.572 15.9816C475.812 15.2947 476.566 14.9421 477.242 15.1772C477.931 15.419 478.289 16.1697 478.048 16.8531C477.854 17.3972 477.901 18.0991 477.951 18.8414C478.001 19.634 478.064 20.5307 477.849 21.4443C477.439 23.1403 476.095 24.5526 474.413 25.0329C473.983 25.1538 473.536 25.2142 473.091 25.2142Z",
    fill: "url(#paint11_linear_58_209)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M403.994 29.8557C403.265 29.8557 402.683 29.2663 402.683 28.5442V16.0437C402.683 15.3148 403.267 14.7322 403.994 14.7322C404.72 14.7322 405.307 15.3165 405.307 16.0437V28.5442C405.307 29.2663 404.718 29.8557 403.994 29.8557Z",
    fill: "url(#paint12_linear_58_209)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_209",
    x1: -0.000839639,
    y1: 14.933,
    x2: 490.001,
    y2: 14.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_209",
    x1: 21.6837,
    y1: 8.06527,
    x2: 69.4187,
    y2: 8.06527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_209",
    x1: 12.3745,
    y1: 9.69625,
    x2: 23.8584,
    y2: 9.69625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_209",
    x1: 85.1895,
    y1: 7.56245,
    x2: 87.815,
    y2: 7.56245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_209",
    x1: 21.6837,
    y1: 21.7875,
    x2: 69.4187,
    y2: 21.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_209",
    x1: 12.3744,
    y1: 20.1612,
    x2: 23.8583,
    y2: 20.1612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_209",
    x1: 85.1895,
    y1: 22.2929,
    x2: 87.815,
    y2: 22.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_209",
    x1: 421.073,
    y1: 8.06563,
    x2: 468.812,
    y2: 8.06563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_58_209",
    x1: 466.637,
    y1: 9.69628,
    x2: 478.124,
    y2: 9.69628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_58_209",
    x1: 402.682,
    y1: 7.56245,
    x2: 405.307,
    y2: 7.56245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_58_209",
    x1: 421.073,
    y1: 21.7872,
    x2: 468.812,
    y2: 21.7872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_58_209",
    x1: 466.638,
    y1: 20.1593,
    x2: 478.124,
    y2: 20.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_58_209",
    x1: 402.682,
    y1: 22.2929,
    x2: 405.307,
    y2: 22.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#C79856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#DFB662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#FAD983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#B27F32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLineIcon);
export default __webpack_public_path__ + "static/media/card_line_icon.61749eb977807734e3e9024832b5697d.svg";
export { ForwardRef as ReactComponent };